<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="1000"
        scrollable
    >
        <v-card>
            <v-toolbar flat dense dark color="blue">
                <v-toolbar-title>
                    {{ documentStore.fichier.fileFullName }}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <iframe
                        v-if="documentUrl"
                        :src="documentUrl"
                        width="100%"
                        height="600px"
                        ref="pdfIframe"
                    />

                    <v-img
                        v-if="imageUrl"
                        :src="imageUrl"
                    ></v-img>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn
                    depressed
                    outlined
                    color="teal"
                    :loading="loading"
                    @click="close"
                >
                    {{ $t('common.close') }}
                    <v-icon right>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {onMounted, ref} from "vue";
import {useDocumentStore} from "@/stores/Edms/Document";
import axios from "axios";

export default {
    name: "DocumentView",
    props: {
        dialog: Boolean
    },
    setup(props, {emit}) {

        const documentStore = useDocumentStore();

        const loading = ref(false);
        const documentUrl = ref(null);
        const imageUrl = ref(null);

        function viewDocument() {
            loading.value = true;
            documentUrl.value = null;
            imageUrl.value = null;
            axios.get(`/documents/download/${documentStore.fichier.id}`, {responseType: 'blob'}).then(response => {
                const extension = documentStore.fichier.fileFullName.split('.')[1];
                if (extension.toLowerCase() === "pdf") {
                    documentUrl.value = URL.createObjectURL(new Blob([response.data], {type: 'application/' + extension}));
                } else {
                    imageUrl.value = URL.createObjectURL(response.data);
                }
            }).finally(() => {
                loading.value = false;
            })
        }

        function close() {
            emit('close');
        }

        onMounted(() => viewDocument());

        return {
            loading,
            documentUrl,
            imageUrl,
            documentStore,
            close,
            viewDocument,
        }
    }
}
</script>

<style scoped>

</style>